import React from "react";

const Footer = () => {
  return (
    <React.Fragment>
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light"
        id="footer"
      >
        <p>Shelcia — Copyright © 2020</p>
      </nav>
    </React.Fragment>
  );
};

export default Footer;
